import request from "../../utils/request";

export interface SeedRequest {
  months?: number;
  employeeCount?: number;
  industry?: string;
  profileJson?: string;
  /**
   * When set, only the named modules run. When null/undefined or empty the
   * backend runs every registered module (legacy behavior).
   */
  enabledModules?: string[];
}

export interface SeedModuleDescriptor {
  order: number;
  name: string;
}

export interface SeedJobResponse {
  jobId: string;
  status: string;
}

export interface SeedJobStatus {
  jobId: string;
  status: string; // Queued | Running | Completed | Failed
  progress: number;
  currentModule: string;
  message: string;
  summary: Record<string, number>;
  durationMs: number;
  error?: string;
}

export async function seedCompany(companyId: number, options: SeedRequest) {
  const response = await request.post<SeedJobResponse>(`dev/seed/company/${companyId}`, options);
  return response.data;
}

export async function getSeedStatus(jobId: string): Promise<SeedJobStatus> {
  const response = await request.get(`dev/seed/status/${jobId}`);
  // SeedController.GetStatus wraps the payload in the Mowazaf Result envelope
  // (`{ status, payload, errors }`). Unwrap it so callers see a SeedJobStatus
  // directly. Fall back to response.data if it already looks unwrapped, so
  // future refactors that switch to a plain Ok(...) don't break the page.
  const body = response.data as { payload?: SeedJobStatus };
  return (body?.payload ?? (response.data as SeedJobStatus));
}

export async function clearCompany(companyId: number) {
  const response = await request.delete<SeedJobResponse>(`dev/seed/company/${companyId}`);
  return response.data;
}

export async function getSeedModules(): Promise<SeedModuleDescriptor[]> {
  const response = await request.get<SeedModuleDescriptor[]>(`dev/seed/modules`);
  const body = response.data as unknown as { payload?: SeedModuleDescriptor[] };
  return body?.payload ?? (response.data as SeedModuleDescriptor[]);
}
